package theme

import kotlinx.js.jso
import mui.system.Theme
import mui.material.styles.createTheme
import mui.material.PaletteMode

val LightTheme: Theme = createTheme(
    jso {
        palette = jso {
            mode = PaletteMode.light
            primary = jso {
                main = Colors.General.main
            }
            secondary = jso {
                main = Colors.General.grey
            }
        }
        typography = jso {
            fontFamily = "\"Century Gothic\", CenturyGothic, AppleGothic, sans-serif;"
        }

    }
)